import type { CasOrCategory } from '../types/db.ts';

// From Table III of https://guideme.epa.gov/ords/guideme_ext/guideme_ext/guideme/file/ry_2023_rfi.pdf
const triTableIiiPotwTransferPercentagesList = [
  { casOrCategory: '56-35-9', '8.1c': 90, '8.1d': 9, '8.7': 1 },
  { casOrCategory: '56-38-2', '8.1c': 9, '8.1d': 2, '8.7': 89 },
  { casOrCategory: '57-14-7', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '57-33-0', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '57-41-0', '8.1c': 2, '8.1d': 51, '8.7': 47 },
  { casOrCategory: '57-74-9', '8.1c': 61, '8.1d': 1, '8.7': 38 },
  { casOrCategory: '58-89-9', '8.1c': 13, '8.1d': 24, '8.7': 63 },
  { casOrCategory: '60-09-3', '8.1c': 8, '8.1d': 35, '8.7': 57 },
  { casOrCategory: '60-11-7', '8.1c': 35, '8.1d': 5, '8.7': 60 },
  { casOrCategory: '50-00-0', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '51-03-6', '8.1c': 39, '8.1d': 3, '8.7': 58 },
  { casOrCategory: '51-21-8', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '51-28-5', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '51-79-6', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '52-68-6', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '53-96-3', '8.1c': 5, '8.1d': 42, '8.7': 53 },
  { casOrCategory: '55-63-0', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '56-23-5', '8.1c': 2, '8.1d': 88, '8.7': 10 },
  { casOrCategory: '60-34-4', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '60-35-5', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '60-51-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '61-82-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '62-53-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '62-55-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '62-56-6', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '62-73-7', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '62-74-8', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '63-25-2', '8.1c': 1, '8.1d': 12, '8.7': 87 },
  { casOrCategory: '64-18-6', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '64-67-5', '8.1c': 0, '8.1d': 5, '8.7': 95 },
  { casOrCategory: '64-75-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '67-56-1', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '67-66-3', '8.1c': 1, '8.1d': 73, '8.7': 26 },
  { casOrCategory: '67-72-1', '8.1c': 18, '8.1d': 56, '8.7': 26 },
  { casOrCategory: '68-12-2', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '70-30-4', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '71-36-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '71-43-2', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '71-55-6', '8.1c': 1, '8.1d': 95, '8.7': 4 },
  { casOrCategory: '72-43-5', '8.1c': 45, '8.1d': 2, '8.7': 53 },
  { casOrCategory: '72-57-1', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '74-83-9', '8.1c': 0, '8.1d': 80, '8.7': 20 },
  { casOrCategory: '74-85-1', '8.1c': 0, '8.1d': 92, '8.7': 8 },
  { casOrCategory: '74-87-3', '8.1c': 1, '8.1d': 59, '8.7': 40 },
  { casOrCategory: '74-88-4', '8.1c': 1, '8.1d': 78, '8.7': 21 },
  { casOrCategory: '74-90-8', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '74-95-3', '8.1c': 1, '8.1d': 61, '8.7': 38 },
  { casOrCategory: '75-00-3', '8.1c': 1, '8.1d': 85, '8.7': 14 },
  { casOrCategory: '75-01-4', '8.1c': 0, '8.1d': 92, '8.7': 8 },
  { casOrCategory: '75-05-8', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '75-07-0', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '75-09-2', '8.1c': 1, '8.1d': 44, '8.7': 55 },
  { casOrCategory: '75-15-0', '8.1c': 1, '8.1d': 87, '8.7': 12 },
  { casOrCategory: '75-21-8', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '75-25-2', '8.1c': 2, '8.1d': 57, '8.7': 41 },
  { casOrCategory: '75-27-4', '8.1c': 1, '8.1d': 68, '8.7': 31 },
  { casOrCategory: '75-34-3', '8.1c': 1, '8.1d': 78, '8.7': 21 },
  { casOrCategory: '75-35-4', '8.1c': 1, '8.1d': 91, '8.7': 8 },
  { casOrCategory: '75-43-4', '8.1c': 1, '8.1d': 91, '8.7': 8 },
  { casOrCategory: '75-44-5', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '75-45-6', '8.1c': 1, '8.1d': 88, '8.7': 11 },
  { casOrCategory: '75-55-8', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '75-56-9', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '98-07-7', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '98-82-8', '8.1c': 7, '8.1d': 13, '8.7': 80 },
  { casOrCategory: '98-86-2', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '98-87-3', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '98-88-4', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '98-95-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '99-55-8', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '99-65-0', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '100-01-6', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '100-02-7', '8.1c': 0, '8.1d': 93, '8.7': 7 },
  { casOrCategory: '100-25-4', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '100-41-4', '8.1c': 3, '8.1d': 45, '8.7': 52 },
  { casOrCategory: '100-42-5', '8.1c': 2, '8.1d': 13, '8.7': 85 },
  { casOrCategory: '100-44-7', '8.1c': 1, '8.1d': 27, '8.7': 72 },
  { casOrCategory: '100-75-4', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '101-05-3', '8.1c': 16, '8.1d': 19, '8.7': 65 },
  { casOrCategory: '101-14-4', '8.1c': 17, '8.1d': 18, '8.7': 65 },
  { casOrCategory: '101-77-9', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '101-80-4', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '101-90-6', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '105-67-9', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '106-42-3', '8.1c': 3, '8.1d': 19, '8.7': 78 },
  { casOrCategory: '106-44-5', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '106-46-7', '8.1c': 7, '8.1d': 49, '8.7': 44 },
  { casOrCategory: '106-47-8', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '106-50-3', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '106-51-4', '8.1c': 1, '8.1d': 59, '8.7': 40 },
  { casOrCategory: '106-88-7', '8.1c': 0, '8.1d': 27, '8.7': 73 },
  { casOrCategory: '106-89-8', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '106-93-4', '8.1c': 1, '8.1d': 60, '8.7': 39 },
  { casOrCategory: '106-94-5', '8.1c': 1, '8.1d': 70, '8.7': 29 },
  { casOrCategory: '106-99-0', '8.1c': 1, '8.1d': 86, '8.7': 13 },
  { casOrCategory: '107-02-8', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '107-05-1', '8.1c': 1, '8.1d': 85, '8.7': 14 },
  { casOrCategory: '107-06-2', '8.1c': 1, '8.1d': 64, '8.7': 35 },
  { casOrCategory: '107-11-9', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '107-13-1', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '107-18-6', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '107-19-7', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '107-21-1', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '107-30-2', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '108-05-4', '8.1c': 0, '8.1d': 11, '8.7': 89 },
  { casOrCategory: '108-10-1', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '108-31-6', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '108-38-3', '8.1c': 3, '8.1d': 18, '8.7': 79 },
  { casOrCategory: '108-39-4', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '124-40-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '124-73-2', '8.1c': 2, '8.1d': 97, '8.7': 1 },
  { casOrCategory: '126-98-7', '8.1c': 1, '8.1d': 27, '8.7': 72 },
  { casOrCategory: '126-99-8', '8.1c': 1, '8.1d': 93, '8.7': 6 },
  { casOrCategory: '127-18-4', '8.1c': 6, '8.1d': 87, '8.7': 7 },
  { casOrCategory: '128-03-0', '8.1c': 1, '8.1d': 28, '8.7': 71 },
  { casOrCategory: '128-04-1', '8.1c': 1, '8.1d': 28, '8.7': 71 },
  { casOrCategory: '131-11-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '132-64-9', '8.1c': 18, '8.1d': 4, '8.7': 78 },
  { casOrCategory: '133-06-2', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '133-07-3', '8.1c': 2, '8.1d': 20, '8.7': 78 },
  { casOrCategory: '134-32-7', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '136-45-8', '8.1c': 6, '8.1d': 3, '8.7': 91 },
  { casOrCategory: '137-26-8', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '137-41-7', '8.1c': 0, '8.1d': 27, '8.7': 73 },
  { casOrCategory: '137-42-8', '8.1c': 0, '8.1d': 27, '8.7': 73 },
  { casOrCategory: '139-13-9', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '140-88-5', '8.1c': 0, '8.1d': 10, '8.7': 90 },
  { casOrCategory: '141-32-2', '8.1c': 1, '8.1d': 9, '8.7': 90 },
  { casOrCategory: '142-59-6', '8.1c': 0, '8.1d': 10, '8.7': 90 },
  { casOrCategory: '148-79-8', '8.1c': 2, '8.1d': 51, '8.7': 47 },
  { casOrCategory: '149-30-4', '8.1c': 2, '8.1d': 52, '8.7': 46 },
  { casOrCategory: '150-50-5', '8.1c': 22, '8.1d': 0, '8.7': 78 },
  { casOrCategory: '151-56-4', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '156-62-7', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '298-00-0', '8.1c': 2, '8.1d': 6, '8.7': 92 },
  { casOrCategory: '300-76-5', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '302-01-2', '8.1c': 0, '8.1d': 15, '8.7': 85 },
  { casOrCategory: '306-83-2', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '309-00-2', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '314-40-9', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '330-54-1', '8.1c': 2, '8.1d': 50, '8.7': 48 },
  { casOrCategory: '330-55-2', '8.1c': 5, '8.1d': 41, '8.7': 54 },
  { casOrCategory: '333-41-5', '8.1c': 12, '8.1d': 7, '8.7': 81 },
  { casOrCategory: '353-59-3', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '354-11-0', '8.1c': 3, '8.1d': 84, '8.7': 13 },
  { casOrCategory: '354-14-3', '8.1c': 3, '8.1d': 84, '8.7': 13 },
  { casOrCategory: '354-23-4', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '924-42-5', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '961-11-5', '8.1c': 7, '8.1d': 11, '8.7': 82 },
  { casOrCategory: '1120-71-4', '8.1c': 1, '8.1d': 29, '8.7': 70 },
  { casOrCategory: '1163-19-5', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '1313-27-5', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '1314-20-1', '8.1c': 90, '8.1d': 10, '8.7': 0 },
  { casOrCategory: '1319-77-3', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '1320-18-9', '8.1c': 15, '8.1d': 0, '8.7': 85 },
  { casOrCategory: '1330-20-7', '8.1c': 3, '8.1d': 17, '8.7': 80 },
  { casOrCategory: '1336-36-3', '8.1c': 61, '8.1d': 1, '8.7': 38 },
  { casOrCategory: '1344-28-1', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '1464-53-5', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '1563-66-2', '8.1c': 1, '8.1d': 7, '8.7': 92 },
  { casOrCategory: '1582-09-8', '8.1c': 57, '8.1d': 3, '8.7': 40 },
  { casOrCategory: '1634-04-4', '8.1c': 1, '8.1d': 60, '8.7': 39 },
  { casOrCategory: '1649-08-7', '8.1c': 1, '8.1d': 97, '8.7': 2 },
  { casOrCategory: '1689-84-5', '8.1c': 6, '8.1d': 13, '8.7': 81 },
  { casOrCategory: '1689-99-2', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '1717-00-6', '8.1c': 1, '8.1d': 96, '8.7': 3 },
  { casOrCategory: '1861-40-1', '8.1c': 56, '8.1d': 3, '8.7': 41 },
  { casOrCategory: '1897-45-6', '8.1c': 3, '8.1d': 18, '8.7': 79 },
  { casOrCategory: '1910-42-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '1912-24-9', '8.1c': 3, '8.1d': 74, '8.7': 23 },
  { casOrCategory: '1918-00-9', '8.1c': 1, '8.1d': 53, '8.7': 46 },
  { casOrCategory: '1918-02-1', '8.1c': 2, '8.1d': 90, '8.7': 8 },
  { casOrCategory: '1918-16-7', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '1928-43-4', '8.1c': 22, '8.1d': 0, '8.7': 78 },
  { casOrCategory: '1929-73-3', '8.1c': 12, '8.1d': 1, '8.7': 87 },
  { casOrCategory: '1929-82-4', '8.1c': 7, '8.1d': 36, '8.7': 57 },
  { casOrCategory: '1982-69-0', '8.1c': 1, '8.1d': 53, '8.7': 46 },
  { casOrCategory: '1983-10-4', '8.1c': 50, '8.1d': 50, '8.7': 0 },
  { casOrCategory: '2155-70-6', '8.1c': 36, '8.1d': 64, '8.7': 0 },
  { casOrCategory: '2164-07-0', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '2164-17-2', '8.1c': 2, '8.1d': 52, '8.7': 46 },
  { casOrCategory: '2234-13-1', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '2300-66-5', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '2303-16-4', '8.1c': 21, '8.1d': 14, '8.7': 65 },
  { casOrCategory: '2303-17-5', '8.1c': 35, '8.1d': 5, '8.7': 60 },
  { casOrCategory: '2312-35-8', '8.1c': 42, '8.1d': 44, '8.7': 14 },
  { casOrCategory: '2699-79-8', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '2702-72-9', '8.1c': 2, '8.1d': 6, '8.7': 92 },
  { casOrCategory: '75-63-8', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '75-65-0', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '75-68-3', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '75-69-4', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '75-71-8', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '75-72-9', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '75-86-5', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '75-88-7', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '76-01-7', '8.1c': 6, '8.1d': 75, '8.7': 19 },
  { casOrCategory: '76-06-2', '8.1c': 1, '8.1d': 88, '8.7': 11 },
  { casOrCategory: '76-13-1', '8.1c': 3, '8.1d': 96, '8.7': 1 },
  { casOrCategory: '76-14-2', '8.1c': 2, '8.1d': 97, '8.7': 1 },
  { casOrCategory: '76-15-3', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '76-44-8', '8.1c': 50, '8.1d': 1, '8.7': 49 },
  { casOrCategory: '76-87-9', '8.1c': 14, '8.1d': 86, '8.7': 0 },
  { casOrCategory: '77-47-4', '8.1c': 44, '8.1d': 11, '8.7': 45 },
  { casOrCategory: '77-73-6', '8.1c': 7, '8.1d': 84, '8.7': 9 },
  { casOrCategory: '77-78-1', '8.1c': 0, '8.1d': 3, '8.7': 97 },
  { casOrCategory: '78-48-8', '8.1c': 37, '8.1d': 0, '8.7': 63 },
  { casOrCategory: '78-84-2', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '78-87-5', '8.1c': 1, '8.1d': 70, '8.7': 29 },
  { casOrCategory: '78-88-6', '8.1c': 1, '8.1d': 67, '8.7': 32 },
  { casOrCategory: '78-92-2', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '79-00-5', '8.1c': 1, '8.1d': 82, '8.7': 17 },
  { casOrCategory: '79-01-6', '8.1c': 1, '8.1d': 93, '8.7': 6 },
  { casOrCategory: '79-06-1', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '79-10-7', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '79-11-8', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '79-19-6', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '79-21-0', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '79-22-1', '8.1c': 0, '8.1d': 1, '8.7': 99 },
  { casOrCategory: '79-34-5', '8.1c': 2, '8.1d': 78, '8.7': 20 },
  { casOrCategory: '79-44-7', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '79-46-9', '8.1c': 1, '8.1d': 26, '8.7': 73 },
  { casOrCategory: '80-05-7', '8.1c': 5, '8.1d': 14, '8.7': 81 },
  { casOrCategory: '80-15-9', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '80-62-6', '8.1c': 0, '8.1d': 10, '8.7': 90 },
  { casOrCategory: '81-07-2', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '82-68-8', '8.1c': 43, '8.1d': 11, '8.7': 46 },
  { casOrCategory: '84-74-2', '8.1c': 29, '8.1d': 1, '8.7': 70 },
  { casOrCategory: '85-01-8', '8.1c': 32, '8.1d': 6, '8.7': 62 },
  { casOrCategory: '85-44-9', '8.1c': 0, '8.1d': 1, '8.7': 99 },
  { casOrCategory: '86-30-6', '8.1c': 5, '8.1d': 42, '8.7': 53 },
  { casOrCategory: '87-62-7', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '87-68-3', '8.1c': 45, '8.1d': 23, '8.7': 32 },
  { casOrCategory: '87-86-5', '8.1c': 54, '8.1d': 4, '8.7': 42 },
  { casOrCategory: '88-06-2', '8.1c': 9, '8.1d': 9, '8.7': 82 },
  { casOrCategory: '88-75-5', '8.1c': 1, '8.1d': 59, '8.7': 40 },
  { casOrCategory: '88-85-7', '8.1c': 12, '8.1d': 54, '8.7': 34 },
  { casOrCategory: '88-89-1', '8.1c': 1, '8.1d': 78, '8.7': 21 },
  { casOrCategory: '90-04-0', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '90-43-7', '8.1c': 3, '8.1d': 5, '8.7': 92 },
  { casOrCategory: '91-08-7', '8.1c': 2, '8.1d': 1, '8.7': 97 },
  { casOrCategory: '91-20-3', '8.1c': 4, '8.1d': 6, '8.7': 90 },
  { casOrCategory: '91-22-5', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '91-59-8', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '91-94-1', '8.1c': 9, '8.1d': 32, '8.7': 59 },
  { casOrCategory: '92-52-4', '8.1c': 10, '8.1d': 2, '8.7': 88 },
  { casOrCategory: '92-67-1', '8.1c': 3, '8.1d': 47, '8.7': 50 },
  { casOrCategory: '92-87-5', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '93-65-2', '8.1c': 5, '8.1d': 42, '8.7': 53 },
  { casOrCategory: '94-11-1', '8.1c': 8, '8.1d': 2, '8.7': 90 },
  { casOrCategory: '94-36-0', '8.1c': 5, '8.1d': 3, '8.7': 92 },
  { casOrCategory: '94-58-6', '8.1c': 10, '8.1d': 30, '8.7': 60 },
  { casOrCategory: '94-59-7', '8.1c': 8, '8.1d': 34, '8.7': 58 },
  { casOrCategory: '94-74-6', '8.1c': 6, '8.1d': 39, '8.7': 55 },
  { casOrCategory: '94-75-7', '8.1c': 2, '8.1d': 6, '8.7': 92 },
  { casOrCategory: '94-80-4', '8.1c': 15, '8.1d': 1, '8.7': 84 },
  { casOrCategory: '95-47-6', '8.1c': 3, '8.1d': 16, '8.7': 81 },
  { casOrCategory: '95-48-7', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '95-50-1', '8.1c': 7, '8.1d': 47, '8.7': 46 },
  { casOrCategory: '95-53-4', '8.1c': 0, '8.1d': 94, '8.7': 6 },
  { casOrCategory: '95-54-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '95-63-6', '8.1c': 11, '8.1d': 21, '8.7': 68 },
  { casOrCategory: '95-80-7', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '95-95-4', '8.1c': 13, '8.1d': 25, '8.7': 62 },
  { casOrCategory: '96-09-3', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '96-12-8', '8.1c': 4, '8.1d': 72, '8.7': 24 },
  { casOrCategory: '96-18-4', '8.1c': 2, '8.1d': 56, '8.7': 42 },
  { casOrCategory: '96-33-3', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '96-45-7', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '108-45-2', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '108-60-1', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '108-88-3', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '108-90-7', '8.1c': 2, '8.1d': 39, '8.7': 59 },
  { casOrCategory: '108-93-0', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '108-95-2', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '109-06-8', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '109-77-3', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '109-86-4', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '110-54-3', '8.1c': 9, '8.1d': 53, '8.7': 38 },
  { casOrCategory: '110-57-6', '8.1c': 2, '8.1d': 27, '8.7': 71 },
  { casOrCategory: '110-80-5', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '110-82-7', '8.1c': 6, '8.1d': 19, '8.7': 75 },
  { casOrCategory: '110-86-1', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '111-42-2', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '111-44-4', '8.1c': 2, '8.1d': 78, '8.7': 20 },
  { casOrCategory: '111-91-1', '8.1c': 1, '8.1d': 78, '8.7': 21 },
  { casOrCategory: '114-26-1', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '115-07-1', '8.1c': 0, '8.1d': 91, '8.7': 9 },
  { casOrCategory: '115-32-2', '8.1c': 44, '8.1d': 2, '8.7': 54 },
  { casOrCategory: '116-06-3', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '117-79-3', '8.1c': 2, '8.1d': 52, '8.7': 46 },
  { casOrCategory: '117-81-7', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '118-74-1', '8.1c': 60, '8.1d': 2, '8.7': 38 },
  { casOrCategory: '119-90-4', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '119-93-7', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '120-12-7', '8.1c': 31, '8.1d': 8, '8.7': 61 },
  { casOrCategory: '120-36-5', '8.1c': 8, '8.1d': 34, '8.7': 58 },
  { casOrCategory: '120-58-1', '8.1c': 7, '8.1d': 36, '8.7': 57 },
  { casOrCategory: '120-71-8', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '120-80-9', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '120-82-1', '8.1c': 19, '8.1d': 22, '8.7': 59 },
  { casOrCategory: '120-83-2', '8.1c': 3, '8.1d': 5, '8.7': 92 },
  { casOrCategory: '121-14-2', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '121-44-8', '8.1c': 1, '8.1d': 56, '8.7': 43 },
  { casOrCategory: '121-69-7', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '121-75-5', '8.1c': 1, '8.1d': 7, '8.7': 92 },
  { casOrCategory: '122-34-9', '8.1c': 2, '8.1d': 77, '8.7': 21 },
  { casOrCategory: '122-39-4', '8.1c': 7, '8.1d': 12, '8.7': 81 },
  { casOrCategory: '122-66-7', '8.1c': 4, '8.1d': 46, '8.7': 50 },
  { casOrCategory: '123-31-9', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '123-38-6', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '123-63-7', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '123-72-8', '8.1c': 0, '8.1d': 9, '8.7': 91 },
  { casOrCategory: '123-91-1', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '354-25-6', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '357-57-3', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '422-56-0', '8.1c': 3, '8.1d': 96, '8.7': 1 },
  { casOrCategory: '460-35-5', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '463-58-1', '8.1c': 0, '8.1d': 84, '8.7': 16 },
  { casOrCategory: '465-73-6', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '492-80-8', '8.1c': 2, '8.1d': 50, '8.7': 48 },
  { casOrCategory: '505-60-2', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '507-55-1', '8.1c': 3, '8.1d': 96, '8.7': 1 },
  { casOrCategory: '510-15-6', '8.1c': 39, '8.1d': 3, '8.7': 58 },
  { casOrCategory: '528-29-0', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '533-74-4', '8.1c': 0, '8.1d': 3, '8.7': 97 },
  { casOrCategory: '534-52-1', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '540-59-0', '8.1c': 1, '8.1d': 74, '8.7': 25 },
  { casOrCategory: '541-41-3', '8.1c': 1, '8.1d': 43, '8.7': 56 },
  { casOrCategory: '541-53-7', '8.1c': 1, '8.1d': 51, '8.7': 48 },
  { casOrCategory: '541-73-1', '8.1c': 8, '8.1d': 47, '8.7': 45 },
  { casOrCategory: '542-75-6', '8.1c': 1, '8.1d': 44, '8.7': 55 },
  { casOrCategory: '542-76-7', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '542-88-1', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '554-13-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '556-61-6', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '563-47-3', '8.1c': 1, '8.1d': 93, '8.7': 6 },
  { casOrCategory: '584-84-9', '8.1c': 2, '8.1d': 1, '8.7': 97 },
  { casOrCategory: '606-20-2', '8.1c': 2, '8.1d': 53, '8.7': 45 },
  { casOrCategory: '612-83-9', '8.1c': 9, '8.1d': 32, '8.7': 59 },
  { casOrCategory: '621-64-7', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '624-83-9', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '630-20-6', '8.1c': 3, '8.1d': 82, '8.7': 15 },
  { casOrCategory: '636-21-5', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '639-58-7', '8.1c': 39, '8.1d': 61, '8.7': 0 },
  { casOrCategory: '684-93-5', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '709-98-8', '8.1c': 4, '8.1d': 44, '8.7': 52 },
  { casOrCategory: '759-73-9', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '759-94-4', '8.1c': 5, '8.1d': 41, '8.7': 54 },
  { casOrCategory: '764-41-0', '8.1c': 1, '8.1d': 84, '8.7': 15 },
  { casOrCategory: '834-12-8', '8.1c': 4, '8.1d': 45, '8.7': 51 },
  { casOrCategory: '872-50-4', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: '2837-89-0', '8.1c': 0, '8.1d': 99, '8.7': 1 },
  { casOrCategory: '2971-38-2', '8.1c': 16, '8.1d': 0, '8.7': 84 },
  { casOrCategory: '3383-96-8', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '3653-48-3', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '4080-31-3', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '4170-30-3', '8.1c': 0, '8.1d': 10, '8.7': 90 },
  { casOrCategory: '4549-40-0', '8.1c': 9, '8.1d': 51, '8.7': 40 },
  { casOrCategory: '5234-68-4', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '7287-19-6', '8.1c': 11, '8.1d': 56, '8.7': 33 },
  { casOrCategory: '7439-92-1', '8.1c': 63, '8.1d': 37, '8.7': 0 },
  { casOrCategory: '7439-96-5', '8.1c': 39, '8.1d': 61, '8.7': 0 },
  { casOrCategory: '7439-97-6', '8.1c': 69, '8.1d': 31, '8.7': 0 },
  { casOrCategory: '7440-02-0', '8.1c': 38, '8.1d': 62, '8.7': 0 },
  { casOrCategory: '7440-22-4', '8.1c': 66, '8.1d': 34, '8.7': 0 },
  { casOrCategory: '7440-28-0', '8.1c': 54, '8.1d': 46, '8.7': 0 },
  { casOrCategory: '7440-36-0', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: '7440-38-2', '8.1c': 49, '8.1d': 51, '8.7': 0 },
  { casOrCategory: '7440-39-3', '8.1c': 69, '8.1d': 31, '8.7': 0 },
  { casOrCategory: '7440-41-7', '8.1c': 37, '8.1d': 63, '8.7': 0 },
  { casOrCategory: '7440-43-9', '8.1c': 68, '8.1d': 32, '8.7': 0 },
  { casOrCategory: '7440-47-3', '8.1c': 76, '8.1d': 24, '8.7': 0 },
  { casOrCategory: '7440-48-4', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: '7440-50-8', '8.1c': 72, '8.1d': 28, '8.7': 0 },
  { casOrCategory: '7440-62-2', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: '7550-45-0', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7632-00-0', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7637-07-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7664-39-3', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7664-41-7', '8.1c': 0, '8.1d': 40, '8.7': 60 },
  { casOrCategory: '7697-37-2', '8.1c': 0, '8.1d': 0, '8.7': 100 },
  { casOrCategory: '7726-95-6', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7758-01-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7782-41-4', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7782-49-2', '8.1c': 44, '8.1d': 56, '8.7': 0 },
  { casOrCategory: '7782-50-5', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '7803-51-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '8001-35-2', '8.1c': 62, '8.1d': 1, '8.7': 37 },
  { casOrCategory: '10028-15-6', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '10034-93-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '10049-04-4', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '10061-02-6', '8.1c': 1, '8.1d': 31, '8.7': 68 },
  { casOrCategory: '10294-34-5', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '12122-67-7', '8.1c': 0, '8.1d': 2, '8.7': 98 },
  { casOrCategory: '12185-10-3', '8.1c': 60, '8.1d': 40, '8.7': 0 },
  { casOrCategory: '12427-38-2', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '13194-48-4', '8.1c': 10, '8.1d': 29, '8.7': 61 },
  { casOrCategory: '13356-08-6', '8.1c': 93, '8.1d': 6, '8.7': 1 },
  { casOrCategory: '13684-56-5', '8.1c': 5, '8.1d': 9, '8.7': 86 },
  { casOrCategory: '14484-64-1', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '15972-60-8', '8.1c': 7, '8.1d': 11, '8.7': 82 },
  { casOrCategory: '17804-35-2', '8.1c': 1, '8.1d': 49, '8.7': 50 },
  { casOrCategory: '19044-88-3', '8.1c': 3, '8.1d': 49, '8.7': 48 },
  { casOrCategory: '19666-30-9', '8.1c': 40, '8.1d': 3, '8.7': 57 },
  { casOrCategory: '20325-40-0', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '20816-12-0', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '20859-73-8', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '21087-64-9', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '21725-46-2', '8.1c': 2, '8.1d': 76, '8.7': 22 },
  { casOrCategory: '22781-23-3', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '23564-05-8', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '23950-58-5', '8.1c': 10, '8.1d': 30, '8.7': 60 },
  { casOrCategory: '25321-14-6', '8.1c': 1, '8.1d': 53, '8.7': 46 },
  { casOrCategory: '25321-22-6', '8.1c': 8, '8.1d': 47, '8.7': 45 },
  { casOrCategory: '25376-45-8', '8.1c': 1, '8.1d': 78, '8.7': 21 },
  { casOrCategory: '26002-80-2', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '26471-62-5', '8.1c': 2, '8.1d': 1, '8.7': 97 },
  { casOrCategory: '26628-22-8', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: '28249-77-6', '8.1c': 8, '8.1d': 35, '8.7': 57 },
  { casOrCategory: '30560-19-1', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '34014-18-1', '8.1c': 2, '8.1d': 77, '8.7': 21 },
  { casOrCategory: '34077-87-7', '8.1c': 1, '8.1d': 98, '8.7': 1 },
  { casOrCategory: '35367-38-5', '8.1c': 13, '8.1d': 6, '8.7': 81 },
  { casOrCategory: '35554-44-0', '8.1c': 15, '8.1d': 21, '8.7': 64 },
  { casOrCategory: '40487-42-1', '8.1c': 47, '8.1d': 1, '8.7': 52 },
  { casOrCategory: '42874-03-3', '8.1c': 39, '8.1d': 3, '8.7': 58 },
  { casOrCategory: '43121-43-3', '8.1c': 3, '8.1d': 48, '8.7': 49 },
  { casOrCategory: '51235-04-2', '8.1c': 19, '8.1d': 16, '8.7': 65 },
  { casOrCategory: '52645-53-1', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '53404-37-8', '8.1c': 21, '8.1d': 0, '8.7': 79 },
  { casOrCategory: '55290-64-7', '8.1c': 1, '8.1d': 55, '8.7': 44 },
  { casOrCategory: '55406-53-6', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '57213-69-1', '8.1c': 1, '8.1d': 25, '8.7': 74 },
  { casOrCategory: '59669-26-0', '8.1c': 1, '8.1d': 24, '8.7': 75 },
  { casOrCategory: '60207-90-1', '8.1c': 9, '8.1d': 32, '8.7': 59 },
  { casOrCategory: '62476-59-9', '8.1c': 12, '8.1d': 25, '8.7': 63 },
  { casOrCategory: '64902-72-3', '8.1c': 1, '8.1d': 54, '8.7': 45 },
  { casOrCategory: '67485-29-4', '8.1c': 53, '8.1d': 0, '8.7': 47 },
  { casOrCategory: '68359-37-5', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '71751-41-2', '8.1c': 44, '8.1d': 2, '8.7': 54 },
  { casOrCategory: '72178-02-0', '8.1c': 3, '8.1d': 47, '8.7': 50 },
  { casOrCategory: '77501-63-4', '8.1c': 31, '8.1d': 0, '8.7': 69 },
  { casOrCategory: '82657-04-3', '8.1c': 38, '8.1d': 0, '8.7': 62 },
  { casOrCategory: '88671-89-0', '8.1c': 9, '8.1d': 32, '8.7': 59 },
  { casOrCategory: '90982-32-4', '8.1c': 1, '8.1d': 23, '8.7': 76 },
  { casOrCategory: '101200-48-0', '8.1c': 2, '8.1d': 22, '8.7': 76 },
  { casOrCategory: '127564-92-5', '8.1c': 3, '8.1d': 96, '8.7': 1 },
  { casOrCategory: 'N010', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: 'N020', '8.1c': 49, '8.1d': 51, '8.7': 0 },
  { casOrCategory: 'N040', '8.1c': 69, '8.1d': 31, '8.7': 0 },
  { casOrCategory: 'N050', '8.1c': 37, '8.1d': 63, '8.7': 0 },
  { casOrCategory: 'N078', '8.1c': 68, '8.1d': 32, '8.7': 0 },
  { casOrCategory: 'N084', '8.1c': 54, '8.1d': 4, '8.7': 42 },
  { casOrCategory: 'N090', '8.1c': 76, '8.1d': 24, '8.7': 0 },
  { casOrCategory: 'N096', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: 'N100', '8.1c': 72, '8.1d': 28, '8.7': 0 },
  { casOrCategory: 'N106', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: 'N171', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: 'N230', '8.1c': 0, '8.1d': 8, '8.7': 92 },
  { casOrCategory: 'N270', '8.1c': 0, '8.1d': 6, '8.7': 94 },
  { casOrCategory: 'N420', '8.1c': 63, '8.1d': 37, '8.7': 0 },
  { casOrCategory: 'N450', '8.1c': 39, '8.1d': 61, '8.7': 0 },
  { casOrCategory: 'N458', '8.1c': 69, '8.1d': 31, '8.7': 0 },
  { casOrCategory: 'N495', '8.1c': 38, '8.1d': 62, '8.7': 0 },
  { casOrCategory: 'N503', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: 'N511', '8.1c': 0, '8.1d': 10, '8.7': 90 },
  { casOrCategory: 'N530', '8.1c': 60, '8.1d': 2, '8.7': 38 },
  { casOrCategory: 'N535', '8.1c': 60, '8.1d': 2, '8.7': 38 },
  { casOrCategory: 'N590', '8.1c': 92, '8.1d': 7, '8.7': 1 },
  { casOrCategory: 'N725', '8.1c': 44, '8.1d': 56, '8.7': 0 },
  { casOrCategory: 'N740', '8.1c': 66, '8.1d': 34, '8.7': 0 },
  { casOrCategory: 'N746', '8.1c': 2, '8.1d': 98, '8.7': 0 },
  { casOrCategory: 'N760', '8.1c': 54, '8.1d': 46, '8.7': 0 },
  { casOrCategory: 'N770', '8.1c': 32, '8.1d': 68, '8.7': 0 },
  { casOrCategory: 'N874', '8.1c': 3, '8.1d': 97, '8.7': 0 },
  { casOrCategory: 'N982', '8.1c': 66, '8.1d': 34, '8.7': 0 },
] as { casOrCategory: CasOrCategory; '8.1c': number; '8.1d': number; '8.7': number }[];

export const triTableIiiPotwTransferPercentagesMap = new Map(
  triTableIiiPotwTransferPercentagesList.map((item) => [item.casOrCategory, item]),
);
